import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  template: `
    <label class="switch">
      <input type="checkbox" id="{{ id }}" [(ngModel)]="value" />
      <span class="slider round"></span>
    </label>
  `,
  styles: [
    `
      .switch {
        position: relative;
        display: inline-block;
        width: 24px;
        height: 12px;
      }

      .switch input {
        display: none;
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      .slider:before {
        position: absolute;
        content: '';
        height: 8px;//13px;
        width: 8px;//12px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      input:checked + .slider {
        background-color: var(--primary);
      }

      input:focus + .slider {
        box-shadow: 0 0 1px var(--primary);
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(13px);
        -ms-transform: translateX(13px);
        transform: translateX(12px);
      }

      /* Rounded sliders */
      .slider.round {
        border-radius: 14px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    `
  ],
  selector: 'input-switch'
})
export class InputSwitchComponent implements OnInit, OnDestroy {

  @Output() public valueChange = new EventEmitter<Boolean>();
  private _value: boolean = false;
  @Input('value')
  public get value(): boolean {
    return this._value;
  }
  public set value(v: boolean) {
    const next = v || false;
    if (next !== this._value) {
      this._value = next;
      this.valueChange.emit(this._value);
    }
  }

  public id: string;

  constructor() {}

  ngOnInit() {
    this.id = '_id_' + Math.floor(Math.random() * 999 + 100);
  }

  ngOnDestroy(): void {}

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-switch.component.ts